import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import { MatTabChangeEvent } from "@angular/material/tabs";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ErrorType } from "src/app/enums/error-type.enum";
import endpoints from "src/app/helpers/endpoints";
import { ApiService } from "src/app/services/api.service";

enum PaymentHistoryType {
  successful = "Successful Payments",
  unsuccessful = "Unsuccessful Payments",
  upcoming = "Upcoming Payments",
  pastDue = "Past Due",
  chargedManually = "Charged Manually"
}

@Component({
  selector: "fury-payments-tabs",
  templateUrl: "./payments-tabs.component.html",
  styleUrls: ["./payments-tabs.component.scss"],
})
export class PaymentsTabsComponent implements OnInit, OnChanges, OnDestroy {
  successfulColumn: string[] = [
    "agreementNumber",
    "createdAt",
    "amount",
    "transactionId",
    "bankName",
    "nameOnAccount",
    "cardType",
    "cardLastFourDigit",
  ];
  upcommingColumn: string[] = [
    "agreementNumber",
    "dueDate",
    "amountPaid",
    "installmentNumber",
    "remainingAmount",
  ];
  chargeManuallyColumn: string[] = [
    "createdAt",
    "category",
    "agreementNumber",
    "claimNumber",
    "chargeManuallyAmount",
  ];
  dataSource = [];
  pageIndex = 0;
  pageSize = 5;
  totalCount = 0;
  @Input() userId = "";
  @Input() editorAccess: boolean;
  @Input() isFetchChargeManuallyApi: boolean;
  selectConfig = { disableOptionCentering: true, panelClass: "custom-class" };
  ngUnsubscribe = new Subject<void>();
  PaymentHistoryType = PaymentHistoryType;
  tabName: PaymentHistoryType = PaymentHistoryType.successful;

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.getSuccessfulPayment('successful');
  }

  onTabChange(event: MatTabChangeEvent) {
    this.dataSource = [];
    this.tabName = event.tab.textLabel as PaymentHistoryType;
    this.pageIndex = 0;
    this.totalCount = 0;
    this.checkTabNameAndProceed();
  }
  getSuccessfulPayment(paymentType: string) {
    this.apiService
      .get(
        `${endpoints.customerDashboard.payment.successfulPayment(
          this.userId, paymentType
        )}?page=${this.pageIndex + 1}&size=${this.pageSize}`
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.body) {
            this.dataSource = res.body?.OrderPaymentDetail?.data;
            this.totalCount = res.body?.OrderPaymentDetail?.total;
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        },
      });
  }
  getUpcommingPayment(isDue:number) {
    this.apiService
      .get(
        `${endpoints.customerDashboard.payment.upcomingPayment(
          this.userId
        )}?page=${this.pageIndex + 1}&size=${this.pageSize}&isDue=${isDue}`
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.body) {
            this.dataSource = res.body?.OrderUpcomingPayment?.data;
            this.totalCount = res.body?.OrderUpcomingPayment?.total;
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        },
      });
  }
  getManuallyCharge() {
    this.apiService
      .get(
        `${endpoints.customerDashboard.payment.getChargeManually(
          this.userId
        )}?page=${this.pageIndex + 1}&size=${this.pageSize}`
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.body) {
            this.dataSource = res.body?.chargeManuallies?.data;
            this.totalCount = res.body?.chargeManuallies?.total;
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        },
      });
  }

  pageSizeChange(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.checkTabNameAndProceed();
  }
  checkTabNameAndProceed(){
    if (this.tabName === PaymentHistoryType.successful) {
      this.getSuccessfulPayment("successful");
    }
    if (this.tabName === PaymentHistoryType.unsuccessful) {
      this.getSuccessfulPayment("unsuccessful");
    }
    if (this.tabName === PaymentHistoryType.upcoming) {
      this.getUpcommingPayment(0);
    }
    if (this.tabName === PaymentHistoryType.chargedManually) {
      this.getManuallyCharge();
    }
    if (this.tabName === PaymentHistoryType.pastDue) {
      this.getUpcommingPayment(1);
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if(changes?.isFetchChargeManuallyApi && this.tabName === "Charged Manually"){ 
      this.getManuallyCharge();
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
